import {
  AccordionItem,
  Text,
  List,
  Stack,
  TextLink,
} from 'braid-design-system';
export const Miscellaneous = () => (
  <AccordionItem id="miscellaneous" label="Miscellaneous">
    <List type="number" start={54}>
      <Text>
        Any written communications between you and us will be made via the email
        address provided as part of your Identification Details.
      </Text>
      <Text>
        These Terms (including other terms referenced within, to the extent
        relevant) constitute the entire agreement between the parties and
        supersede all other representations or agreements, whether written or
        oral, between us relating to this matter.
      </Text>
      <Text>
        We may assign or novate rights and obligations under these Terms without
        your consent.
      </Text>
      <Text>
        Any clause within these Terms which is wholly or partially void or
        unenforceable is severed to the extent that it is void or unenforceable.
        The validity or enforceability of the remainder of these Terms is not
        affected.
      </Text>
      <Text>
        These terms do not create a partnership, joint venture or agency
        relationship between you and us and you will not make any statement
        which suggests such a relationship. You must not state that any member
        of the SEEK Group sponsors or endorses your business or product without
        our prior written approval.
      </Text>
      <Stack space="medium">
        <Text>
          If you are a third party provider accessing the SEEK API to service
          Mutual Customers:
        </Text>
        <List type="alpha">
          <Text>
            your contractual relationship is with SEEK Limited (ACN 080 075
            314);
          </Text>
          <Text>
            these Terms are governed by the laws of Victoria, Australia. Each
            party irrevocably and unconditionally submits to the exclusive
            jurisdiction of the courts of Victoria, Australia; and
          </Text>
          <Text>
            SEEK Limited reserves the right to assign or novate these Terms (or
            any aspect of these Terms) to any member of the SEEK Group without
            your consent. If this occurs, we may elect to amend the details in
            clause 59 a). We will notify you of such changes 30 days in advance.
          </Text>
        </List>
      </Stack>
      <Text>
        If you are an Advertiser that accesses the SEEK API directly (i.e. you
        do not use a third party provider), these Terms are incorporated into
        the{' '}
        <TextLink href="/support/termsconditions">
          Advertising Terms of Use
        </TextLink>
        , which also apply to you. This means that the provisions of the{' '}
        <TextLink href="/support/termsconditions">
          Advertising Terms of Use
        </TextLink>{' '}
        (including those relating to contracting parties and governing law) also
        apply to these Terms. In the event of any conflict, these Terms prevail.{' '}
      </Text>
      <Text>
        Any member of the SEEK Group may assist in providing the relevant
        products and services to you.{' '}
      </Text>
    </List>
  </AccordionItem>
);
